// extracted by mini-css-extract-plugin
module.exports = {"uppercase":"Waiting_uppercase__184Mt"};